import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { required } from './Fields/config'
import RHFDatePickerInput from './Fields/RHFDatePickerInput'
import Input from './Fields/RHFInput'
import TextArea from './Fields/RHFTextArea'
import { useDefaultDatePickerMonthYear } from './Hooks/useDefaultDates'
import type { CreateNoteItemViewModel } from '../Create/models'
import type { PatchNoteItemViewModel } from '../Edit/models'

import Group from 'components/utils/Group'

interface Props {
  tripId: string
}

function NoteFields({ tripId }: Props) {
  const intl = useIntl()
  const { register, watch } = useFormContext<
    CreateNoteItemViewModel | PatchNoteItemViewModel
  >()

  const { defaultMonth, defaultYear } = useDefaultDatePickerMonthYear({
    tripId,
  })

  const isSectionHeaderSelected = !!watch('isSectionHeader')

  const titleLabel = intl.formatMessage({
    id: 'Gh3xeqoWwQ',
    defaultMessage: 'Title',
    description: 'Form label for title field in note trip item editor',
  })

  const titlePlaceholder = intl.formatMessage({
    id: '4ARkqDJ1bi',
    defaultMessage: 'Add Title',
    description: 'Placeholder text for title input in note trip item editor',
  })

  const noteLabel = intl.formatMessage({
    id: 'lRr3NcH5mn',
    defaultMessage: 'Note',
    description: 'Form label for note content field in note trip item editor',
  })

  const dateLabel = intl.formatMessage({
    id: 'LQRsbwZ0fQ',
    defaultMessage: 'Date',
    description: 'Form label for date field in note trip item editor',
  })

  const selectDatePlaceholder = intl.formatMessage({
    id: 'KTr4HPcRBZ',
    defaultMessage: 'Select date',
    description: 'Placeholder text for date picker in note trip item editor',
  })

  return (
    <>
      <Input
        {...register('title', {
          required: isSectionHeaderSelected ? required : undefined,
        })}
        required={isSectionHeaderSelected}
        label={titleLabel}
        placeholder={titlePlaceholder}
      />

      <TextArea
        {...register('notes', { required })}
        required
        label={noteLabel}
        placeholder="Add note here"
        resize="vertical"
        rows={4}
      />
      <Group direction="vertical" horizontalAlign="stretch" gap={16}>
        <RHFDatePickerInput
          name="startDate"
          label={dateLabel}
          required={isSectionHeaderSelected}
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
          placeholder={selectDatePlaceholder}
        />
      </Group>
    </>
  )
}

export default NoteFields
